export default "__VITE_ASSET__DPk0SojF__"